<template>
  <main>
    <div class="container dark-grey-text mt-5">
      <div class="row wow fadeIn">
        <div class="col-md-4 mb-4">
          <img
            class="img-fluid img-thumbnail"
            src="../../public/img/airtime.jpg"
            alt="airtime"
          />
        </div>
        <div class="col-md-8 mb-4">
          <h2>Buying airtime</h2>
          <p>Our system will automatically select the provider</p>
          <div class="p-1">
            <form id="form" action="post">
              <div class="row">
                <div class="form-group  col-md-6">
                  <p class="font-weight-bold">Reciever Number</p>

                  <vue-phone-number-input id="Umbai" 
                  v-model="receiverNumber" 
                  default-country-code="ZW" 
                  no-example
                  required size="lg" 
                  maxlength="12"
                  @update="ValidateReceiverNumber"
                  />
                  <div><span class="text-warning">{{valideReceiverNumberMessage}}</span></div>
                </div>
                <div class="form-group col-md-6">
                  <p class="font-weight-bold">Sender Number</p>
                  <vue-phone-number-input id="Umbai"
                  v-model="senderNumber"
                  default-country-code="ZA" 
                  required size="lg"
                  no-example
                  maxlength="12" 
                  @update="ValidateSenderNumber"
                  />
                  <div><span class="text-warning">{{valideSenderNumberMessage}}</span></div>
                </div>
              </div>
              <p class="lead font-weight-bold">Airtime Amount (ZWD)</p>
              <select v-model="selected" required class="form-control">
                <option
                  v-for="(value, name, index) in AirTimeValues.airtimes"
                  :value="value"
                  :key="index"
                >
                  ZWD${{ name }} ( R{{ value.totalAmount }})
                </option>
              </select>
              <br />
              <base-button
                class="btn-3"
                @click="CheckOutProduct"
                type="primary"
                icon="ni ni-credit-card"
                >Proceed to payment</base-button
              >
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
  <!--Main layout-->
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  components: {
    VuePhoneNumberInput,
  },
  data: function() {
    return {
      valideSenderNumberMessage:"",
      valideReceiverNumberMessage:"",
      senderNumber:"",
      receiverNumber:"",
      isSenderNumberValid:false,
      isReceiverNumberValid:false,
      key: "",
      selected: {
        salesCurrencyAmount: 0,
        baseCurrencyAmount: 0,
        inHouseServiceFeeTotal: 0,
        paymentProviderServiceFeeTotal: 0,
        totalAmount: 0,
      },
      checkOut:{
        senderNumber: "",
        recepientNumber:"",
        product: "",
        key: "",
      },
    };
  },
  created() {
    this.$store.dispatch("airtimeproduct/getAirTimeProducts");
  },
  computed: {
    ...mapGetters("airtimeproduct", ["AirTimeValues"]),
  },
  methods: {
    ValidateSenderNumber(payload) {
    if (payload.isValid) {
      this.valideSenderNumberMessage = "";
      this.checkOut.senderNumber = payload.countryCallingCode + payload.nationalNumber;
      this.isSenderNumberValid = true;
    } else {
      this.valideSenderNumberMessage = "Please make sure mobile number is valid!";
      this.isSenderNumberValid = false;
    }
  },
    ValidateReceiverNumber(payload) {
    if (payload.isValid) {
      this.valideReceiverNumberMessage = "";
      this.checkOut.recepientNumber = payload.countryCallingCode + payload.nationalNumber;
      this.isReceiverNumberValid = true;
    } else {
      this.valideReceiverNumberMessage = "Please make sure mobile number is valid!";
      this.isReceiverNumberValid = false;
    }
   },
    CheckOutProduct(e) {
      e.preventDefault();
      if(!this.isReceiverNumberValid || !this.isSenderNumberValid) return;
      this.checkOut.product= this.selected;
      this.checkOut.key= this.AirTimeValues.key;
      this.$store.dispatch("cart/addProductToCheckOut", this.checkOut);
      this.$router.push("Checkout");
    },
  },
};
</script>
